// Copyright (c) 2015, Alphamonak Solutions

if (melon.require) {
	melon.require("file_uploader.bundle.js");
} else {
	melon.ready(function () {
		melon.require("file_uploader.bundle.js");
	});
}
